"use client"

import { defineRecipe } from "@chakra-ui/react"

const buttonRecipe = defineRecipe({
  variants: {
    variant: {
      hydrologiq_icon: {
        color: "primary",
        padding: "5px",
        borderRadius: "5px",
        _hover: {
          color: "white",
          bg: "#0bc5ea",
        },
        "&.hover": {
          color: "white",
          bg: "#0bc5ea",
        },
        "&.active": {
          color: "white",
          bg: "#0bc5ea",
        },
        "&[data-state='open']": {
          color: "white",
          bg: "#0bc5ea",
        },
        _disabled: {
          bg: "transparent !important",
          color: "primary !important",
          opacity: 0.5,
          cursor: "not-allowed",
        },
      },
      hydrologiq_primary: {
        "&[type='submit'], &": {
          color: "white",
          bg: "#39aed2",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "#39aed2",
          fontSize: "1em",
        },
        _hover: {
          bg: "#0bc5ea",
          borderColor: "#0bc5ea",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      hydrologiq_secondary: {
        "&[type='submit'], &": {
          color: "#39aed2",
          bg: "card",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "#39aed2",
          fontSize: "1em",
        },
        "&.active": {
          bg: "#0bc5ea",
          color: "white",
          borderColor: "#0bc5ea",
        },
        _hover: {
          bg: "#0bc5ea",
          color: "white",
          borderColor: "#0bc5ea",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      confirmation: {
        "&[type='submit'], &": {
          color: "green",
          bg: "card",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "green",
          fontSize: "1em",
        },
        _hover: {
          bg: "#0bc5ea",
          color: "white",
          borderColor: "#0bc5ea",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      active: {
        "&[type='submit'], &": {
          color: "active",
          bg: "card",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "active",
          fontSize: "1em",
        },
        _hover: {
          bg: "highlight",
          color: "white",
          borderColor: "highlight",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      warning: {
        "&[type='submit'], &": {
          color: "white",
          bg: "error",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "error",
          fontSize: "1em",
        },
        _hover: {
          bg: "error_light",
          color: "white",
          borderColor: "error_light",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      inactive: {
        "&[type='submit'], &": {
          color: "primary",
          bg: "card",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "primary",
          fontSize: "1em",
        },
        _hover: {
          bg: "#39aed2",
          color: "white",
          borderColor: "#39aed2",
        },
        "&:disabled": {
          bg: "#39aed2",
          borderColor: "#39aed2",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      magic: {
        "&[type='submit'], &": {
          color: "white",
          bg: "linear-gradient(100deg, #39aed2 0%, #a170d9 100%)",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "linear-gradient(100deg, #39aed2 0%, #a170d9 100%)",
          fontSize: "1em",
        },
        _hover: {
          bg: "linear-gradient(100deg, #a170d9 0%, #0bc5ea 100%)",
          borderColor: "linear-gradient(100deg, #a170d9 0%, #0bc5ea 100%)",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      light: {
        "&[type='submit'], &": {
          color: "white",
          bg: "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          fontSize: "1em",
        },
        "&.active": {
          color: "white",
          bg: "active",
        },
        _hover: {
          color: "white",
          bg: "active",
        },
        "&:disabled": {
          bg: "#a9a9a9",
          borderColor: "#a9a9a9",
          color: "primary",
          cursor: "not-allowed",
        },
      },
      highlight: {
        "&[type='submit'], &": {
          color: "white",
          bg: "highlight",
          paddingInlineEnds: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          lineHeight: "1.2",
          borderRadius: "5px",
          fontSize: "1em",
        },
        "&.active": {
          color: "white",
          bg: "active",
        },
        _hover: {
          color: "white",
          bg: "active",
        },
        "&:disabled": {
          opacity: 1,
          cursor: "not-allowed",
          color: "white",
          bg: "transparent",
        },
      },
    },
  },
})

// $color-darkblue: #3182ce;
// $color-blue: #39aed2;
// $color-blue-hover: #0bc5ea;
// $color-lightblue: #eaf7fa;
// $color-purple: #a170d9;
// $color-purple-hover: #c09fe6;
// $color-grey: #a9a9a9;
// $color-grey-hover: #cbcbcb;
// $color-lightgrey: #dddddd;
// $color-darkgrey: #444444;
// $color-amber: #f0986f;
// $color-lightamber: #f9d6c5;
// $color-white: white;
// $color-primary: primary;
// $color-red: #d2042d;
// $color-green: #50c878;

// .primary-btn {
//   background-color: $color-blue !important;
//   border: 1.5px solid $color-blue !important;
//   color: $color-white !important;
//   border-radius: 5px;

//   &:hover {
//     background-color: $color-blue-hover !important;
//     border-color: $color-blue-hover !important;
//     color: $color-white !important;
//   }
// }

// .secondary-btn {
//   background-color: $color-white !important;
//   border: 1.5px solid $color-blue !important;
//   color: $color-blue !important;
//   border-radius: 5px;

//   &.active,
//   &[aria-expanded="true"],
//   &:hover {
//     @extend .primary-btn;
//   }
// }

export default buttonRecipe
